import { Outlet, Navigate, useLocation } from 'react-router-dom'

export function InvestmentPage() {
  const location = useLocation()
  const isIndex = location.pathname === '/investment' || location.pathname === '/investment/'

  if (isIndex) {
    return <Navigate to="/investment/strategies" replace />
  }

  return <Outlet />
} 